import ImageGallery from 'components/gallery'
import * as Context from './Context'
import * as Figures from './Figure'
import styles from './Gallery.module.css'

export default function Gallery() {
    const { images } = Context.useReport()

    if (!Array.isArray(images) || images.length === 0) {
        return null
    }

    return (
        <ImageGallery
            renderItem={renderItem}
            items={images}
            showBullets={images.length > 1}
            showPlayButton={images.length > 1}
            showThumbnails={false}
        />
    )
}

// Constants and utils
function renderItem({ caption, ...image }) {
    function handleClick() {
        const url = Figures.interpolate(image.url, '9999')

        window.open(url, image.id)
    }

    return (
        <Figures.Figure>
            <Figures.Image
                {...image}
                sizes={SIZES}
                onClick={handleClick}
                className={styles.Image}
            />
            {caption && <Figures.Caption className={styles.Caption}>{caption}</Figures.Caption>}
        </Figures.Figure>
    )
}
const SIZES = ['(min-width: 1026px) calc(1026px - 2em)', 'calc(100vw - 2em)']
